import React, { useState } from "react";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Select,
  MenuItem,
  Card,
  CardContent,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import {
  FormControl,
  InputLabel,
} from "@mui/material";
import Controls from "../../../components/controls/Controls";
import Popup from "../../../components/customHelpers/Popup";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import UpdateCompany from "../../../components/forms/admin";
import { useHistory } from "react-router-dom";

import Staff from "../../../actions/staff";
import { useEffect } from "react";
import { signout } from "../../../actions/auth";

const sessionDurations = [
  { label: "5 Minutes", value: "5m" },
  { label: "10 Minutes", value: "10m" },
  { label: "15 Minutes", value: "15m" },
  { label: "20 Minutes", value: "20m" },
  { label: "30 Minutes", value: "30m" },
  { label: "1 Hour", value: "1h" },
  { label: "2 Hours", value: "2h" },
  { label: "3 Hours", value: "3h" },
  { label: "4 Hours", value: "4h" },
  { label: "5 Hours", value: "5h" },
  { label: "6 Hours", value: "6h" },
];
const useStyles = makeStyles(() => ({
  container: {
    marginBottom: "24px", 
  },
  card: {
    marginBottom: "16px",
    borderRadius: "8px",  
    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)", 
  },
  cardContent: {
    padding: "24px", 
  },
  primaryText: {
    fontWeight: "bold",
    color: "rgba(244,151,3,0.8)", 
    marginBottom: "8px", 
  },
  secondaryText: {
    color: "rgb(20,61,89)", 
  },
  fieldContainer: {
    marginBottom: "16px", 
    "&:last-child": {
      marginBottom: 0,
    },
  },
  sessionControl: {
    minWidth: "150px",
    marginTop: "16px",
  },
}));


const CompanyDetail = ({ getAdminData, company }) => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const [duration, setDuration] = useState("2m");
  const [temp, setTemp] = useState(null);
  const classes = useStyles();
  const history = useHistory();

  const [openPopup, setOpenPopup] = useState(false);
  const [edit, setEdit] = useState(false);
  const { viewSession, addSession, updateSession } = Staff();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getSession();
  }, [reload]);
  const getSession = () => {
    setValues({ ...values, loading: true });
    viewSession().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.session) {
        setValues({
          ...values,
          loading: false,
        });
        setDuration(data.session.duration);
        setTemp(data.session.duration);
      }
    });
  };
  const handleChange = (e) => {
    setDuration(e.target.value);
  };
  const handleSave = () => {
    if (temp) {
      updateSession({ duration: duration }).then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
          setValues({
            ...values,
            loading: false,
          });
        } else if (data.session) {
          setValues({
            ...values,
            loading: false,
          });
          NotifyMessage({
            message: "Session successfully updated",
            type: "success",
          });
        }
      });
    } else {
      addSession({ duration: duration }).then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
          setValues({
            ...values,
            loading: false,
          });
        } else if (data.session) {
          setValues({
            ...values,
            loading: false,
          });
          NotifyMessage({
            message: "Session successfully created",
            type: "success",
          });
          setDuration(data.session.duration);
        }
      });
    }
  };
  return (
    <>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12} md={6}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography variant="h6" gutterBottom>
                Company Details
              </Typography>

              <Grid container spacing={3}>
                {/* Left Column */}
                <Grid item xs={12} md={6}>
                  <div className={classes.fieldContainer}>
                    <Typography
                      variant="subtitle2"
                      className={classes.primaryText}
                    >
                      Email
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.secondaryText}
                    >
                      {company?.email}
                    </Typography>
                  </div>

                  <div className={classes.fieldContainer}>
                    <Typography
                      variant="subtitle2"
                      className={classes.primaryText}
                    >
                      Phone
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.secondaryText}
                    >
                      {company?.phoneNo}
                    </Typography>
                  </div>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} md={6}>
                  <div className={classes.fieldContainer}>
                    <Typography
                      variant="subtitle2"
                      className={classes.primaryText}
                    >
                      Organization Name
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.secondaryText}
                    >
                      {company?.organization_name}
                    </Typography>
                  </div>

                  <div className={classes.fieldContainer}>
                    <Typography
                      variant="subtitle2"
                      className={classes.primaryText}
                    >
                      Address
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.secondaryText}
                    >
                      {company?.address}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Controls.Button
                text={"Edit Company Details"}
                size="medium"
                variant="contained"
                color="primary"
                style={{ marginTop: 16 }}
                onClick={() => {
                  setOpenPopup(true);
                  setEdit(true);
                }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography variant="subtitle1" gutterBottom>
                Update Session Duration
              </Typography>

              <FormControl variant="outlined" fullWidth>
                <InputLabel>Select Session Duration</InputLabel>
                <Select
                  value={duration}
                  onChange={handleChange}
                  label="Select Session Duration"
                >
                  {sessionDurations.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Controls.Button
                text={temp ? "Update" : "Save"}
                size="medium"
                variant="contained"
                color="primary"
                className={classes.sessionControl}
                onClick={handleSave}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Notification notify={notify} setNotify={setNotify} />

      <Popup
        title="Admin Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <UpdateCompany
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={company}
          getAdminData={getAdminData}
        />
      </Popup>
    </>
  );
};
export default CompanyDetail;
